export default __webpack_public_path__ + "static/media/Lorenzo Olindo.a548dde8.jpg";